import React from 'react';
import DisplayField from '../../../../../itrust_common/components/others/DisplayField'
import OldValuesHeader from '../../oldValues/OldValuesHeader';

let GlassView = props => {
  const { template, previousExams, fieldKey, overviewName, examId, fieldsValues } = props;

  const renderTable = (fieldsValues) => (
    <div className="col-12">
      <div className="overview-table mb-3">
        <table className="table table-bordered bg-light table-hover shadow-none border border-muted">
          <thead className="text-dark border border-muted">
            <tr className="text-center">
              <th scope="col"></th>
              <th scope="col"><DisplayField isVisible={template.fields.od_sphere.visible} label={template.fields.od_sphere.custom_label} /></th>
              <th scope="col"><DisplayField isVisible={template.fields.od_cylinder.visible} label={template.fields.od_cylinder.custom_label} /></th>
              <th scope="col"><DisplayField isVisible={template.fields.od_axis.visible} label={template.fields.od_axis.custom_label} /></th>
              <th scope="col"><DisplayField isVisible={template.fields.od_add.visible} label={template.fields.od_add.custom_label} /></th>
              <th scope="col"><DisplayField isVisible={template.fields.od_prism.visible} label={template.fields.od_prism.custom_label} /></th>
              <th scope="col"><DisplayField isVisible={true} label={"Distance"} /></th>
              <th scope="col"><DisplayField isVisible={true} label={"Near"} /></th>
            </tr>
          </thead>
          <tbody>
            {["od", "os", "ou"].map(type =>
              <tr className="text-center">
                <td><h6>{type.toUpperCase()}</h6></td>
                <td><DisplayField isVisible={true} value={fieldsValues && fieldsValues[`${type}_sphere`]} /></td>
                <td><DisplayField isVisible={true} value={fieldsValues && fieldsValues[`${type}_cylinder`]} /></td>
                <td><DisplayField isVisible={true} value={fieldsValues && fieldsValues[`${type}_axis`]} /></td>
                <td><DisplayField isVisible={true} value={fieldsValues && fieldsValues[`${type}_add`]} /></td>
                <td><DisplayField isVisible={true} value={fieldsValues && fieldsValues[`${type}_prism`]} /></td>
                <td><DisplayField isVisible={true} value={fieldsValues && fieldsValues.visual_acuity && fieldsValues.visual_acuity[`${type}_distance`]} /></td>
                <td><DisplayField isVisible={true} value={fieldsValues && fieldsValues.visual_acuity && fieldsValues.visual_acuity[`${type}_near`]} /></td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      { fieldsValues && fieldsValues.notes && <DisplayField
        isVisible={template.fields.notes.visible}
        label={`${template.fields.notes.custom_label}:`}
        value={fieldsValues.notes}
        className=""
      /> }
    </div>
  )

  return (
    <>
      {fieldsValues && renderTable(fieldsValues)}
      {previousExams
        ?.filter(item => item.id !== examId)
        .flatMap(prevExam => {
          const values = (Array.isArray(prevExam?.[fieldKey]) ? prevExam[fieldKey] : [prevExam?.[fieldKey]]).filter(Boolean);
          if (!values.length) return [];

          return values.map((value, index) => (
            <div className="col-12 border rounded mb-4 px-0" key={`${prevExam.id}-${value.id || index}`}>
              <div className="row mx-0">
                <OldValuesHeader
                  prevExam={prevExam}
                  overviewName={overviewName}
                  examId={examId}
                  importIds={value.id ? [value.id] : []}
                />
                <div className="col-12">
                  {values.length > 1 && <h6 className="pt-4 px-3">Current Glass #{index + 1}</h6>}
                  {renderTable(value)}
                </div>
              </div>
            </div>
          ));
        })}
    </>
  )
}


export default GlassView;